import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import airbnbADUImage from '@/assets/airbnb-adu.jpg';

const CanIAirbnbMyADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/airbnb-adu-rules-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={airbnbADUImage} 
              alt="Guests checking into ADU Airbnb" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can I Airbnb My ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand California's rules for short-term rental ADUs, including Airbnb regulations, permit requirements, and city-specific restrictions.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California ADU Short-Term Rental Laws
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California permits ADU short-term rentals under specific conditions, but local jurisdictions can impose additional restrictions. State law doesn't prohibit Airbnb use in ADUs, however cities may require special permits, impose occupancy limits, or restrict short-term rental operations in certain zoning areas.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-Specific Airbnb Regulations
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Los Angeles requires transient occupancy registration and limits short-term rentals to 120 days annually. San Francisco mandates host registration and permanent residency requirements. San Diego has specific ADU short-term rental permits with neighborhood impact assessments. Each city maintains unique Airbnb compliance requirements.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Compliance and Permit Requirements
              </h2>
              <p className="text-white leading-relaxed mb-6">
                ADU Airbnb operations typically require business licenses, transient occupancy tax registration, and compliance with fire safety codes. Some jurisdictions mandate liability insurance, guest limits, and noise ordinance adherence. Professional consultation ensures full compliance with local short-term rental regulations and ADU-specific requirements.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Are there restrictions on Airbnb rentals in California ADUs?</p>
                  <p>A: Yes, local cities often impose additional permit requirements and operational restrictions.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Do I need special permits to Airbnb my ADU?</p>
                  <p>A: Most cities require short-term rental permits, business licenses, and transient occupancy registration.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanIAirbnbMyADUCalifornia;